/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Reveal_Done2Inputs */

const en_settings_reportingapikeys_reveal_done2 = /** @type {(inputs: Settings_Reportingapikeys_Reveal_Done2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Settings_Reportingapikeys_Reveal_Done2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_reveal_done2 = /** @type {((inputs?: Settings_Reportingapikeys_Reveal_Done2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Reveal_Done2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_reveal_done2(inputs)
});
export { settings_reportingapikeys_reveal_done2 as "settings_reportingApiKeys_reveal_done" }